import { render, staticRenderFns } from "./KnowledgeManageSettingsRowHeader.vue?vue&type=template&id=20549844&scoped=true&"
import script from "./KnowledgeManageSettingsRowHeader.vue?vue&type=script&lang=js&"
export * from "./KnowledgeManageSettingsRowHeader.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeManageSettingsRowHeader.vue?vue&type=style&index=0&id=20549844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20549844",
  null
  
)

export default component.exports